import {Environment} from './environment.interface';
import {Env} from './env.enum';

export const environment: Environment = {
  production: Env.DEV,
  pappersApiUrl: '',
  pappersApiKey: '',

  // Backend API public url
  // apiUrl: 'http://192.168.1.133:8080/api/v1'
  apiUrl: 'http://localhost:8080/api/v1'
};
